export default {
    install(Vue) {
        Vue.prototype.$round = function (value) {
            if (Number(value) === value && value % 1 !== 0) {
                return value.toFixed(2)
            }
            return value
        }
    }
}